/**
 * Builder de `playerSource` HLS+FairPlay para Bitmovin.
 *
 * Espejo del `getHLS` que vive en `containers/bitmovinPlayer/utils/encodes/`
 * (el que usa LivePlayer) — la diferencia es el contrato de `media`:
 *
 * - LivePlayer recibe `media` en snake_case (`video_url`, `server_url`,
 *   `certificate_url`) porque el endpoint `media-info` legacy responde así.
 * - El servicio `getMatchPlaybackService` (Mundial2026) responde en
 *   camelCase (`videoUrl`, `serverUrl`, `certificateUrl`).
 *
 * El envelope DRM (form-urlencoded con spc/token/device_id/skd_payload) y la
 * decodificación del CKC (`<ckc>base64</ckc>`) son idénticos: el license
 * server `getckc` es el mismo backend de Claro para todos los productos.
 */
export const getHLS = (media, deviceId) => {
  // El `challenge` viene como string JSON. En Mundial2026 trae `token` y
  // `material_id` directos; defensivo igual contra el caso histórico con
  // `custom-data` envuelto para no romper si algún canal viene en formato
  // legacy.
  let challenge = null;
  if (media?.challenge) {
    challenge = JSON.parse(media.challenge);
    if (challenge?.['custom-data']) {
      challenge.token = JSON.parse(challenge['custom-data'])?.token;
    }
  }

  const playerSource = {
    hls: media.videoUrl,
    drm: {
      fairplay: {
        LA_URL: media.serverUrl,
        certificateURL: media.certificateUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        licenseResponseType: 'arraybuffer',
        prepareCertificate: certificate => new Uint8Array(certificate),
        prepareContentId: contentId => {
          const arr = contentId.split('skd://');
          return arr[arr.length - 1];
        },
        prepareMessage: (event, session) => {
          const { messageBase64Encoded } = event;
          const base64Payload = messageBase64Encoded
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
          const token = challenge?.token || '';
          const { contentId } = session;
          return `spc=${base64Payload}&token=${token}&device_id=${deviceId}&skd_payload=${contentId}`;
        },
        prepareLicense: data => {
          let responseText = new TextDecoder().decode(data);
          responseText = responseText
            .trim()
            .replace('<ckc>', '')
            .replace('</ckc>', '');
          return Uint8Array.from(atob(responseText), c => c.charCodeAt(0));
        },
      },
    },
  };
  return playerSource;
};
